import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"
import { useEffect } from "preact/hooks";

export default function NoResults() {
    const { response: { query }, pageType } = useAppState();

    useEffect(() => {
        if(!window.nostojs) return;
        window.nostojs(api => {
            api
            .createRecommendationRequest({ includeTagging: true })
            .setElements([ "nosearchpage-nosto-3" ])
            .load({ skipPageViews: true, skipEvents: true })
        })
    }, [])

    return (
        <div className="w-full py-8  lg:py-10  px-5 lg:px-0 text-center lg:flex lg:flex-col lg:items-center lg:justify-center">
            <div className="lg:hidden">
                <nav className="body-2" role="navigation">
                    <ol className="flex md:pt-[0.938rem] md:pb-[0.313rem] justify-center gap-2 md:justify-start pt-[1.875rem] pb-2.5 !px-5 !py-0 mb-2 !justify-center !items-center">
                        <li><a href="/">Home</a></li>
                        <li>/</li>
                        {pageType === 'search'
                            ?   <li>Search results for {query}</li>
                            :   <li>No results found. Please try removing filters.</li>
                        }
                    </ol>
                </nav>
            </div>
            {pageType === 'search'
                ?   <h2 className="mb-2 lg:mb-2.5 max-w-[300px] mx-auto">No results for "{query}".</h2>
                :   <>
                        <h2 className="mb-2 lg:mb-2.5 max-w-[300px] mx-auto">No results found.</h2>
                        <p>Please try removing filters.</p>
                    </>   
            }
            <div class="nosto_element relative w-full" id="nosearchpage-nosto-3"></div>
        </div>
    )
}
